import { render, staticRenderFns } from "./ProfileGrids.vue?vue&type=template&id=0fc0000c&scoped=true"
import script from "./ProfileGrids.vue?vue&type=script&lang=js"
export * from "./ProfileGrids.vue?vue&type=script&lang=js"
import style0 from "./ProfileGrids.vue?vue&type=style&index=0&id=0fc0000c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc0000c",
  null
  
)

export default component.exports